import { render, staticRenderFns } from "./PasswordLockIcon.vue?vue&type=template&id=48f0b39d&"
import script from "./PasswordLockIcon.vue?vue&type=script&lang=js&"
export * from "./PasswordLockIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports